import { makeStyles, Typography } from "@material-ui/core";
import { HashLink  } from 'react-router-hash-link';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 600,
    margin: '0 auto',
    padding: '100px 15px',
    fontSize: 16,
  },
  link: {
    display: "block",
    marginBottom: 10,
  },
  h1: {
    fontSize: 36,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 10,
  },
  description: {
    fontSize: 24,
    color: 'grey',
    textAlign: 'center',
    marginBottom: 10,
    fontWeight: 700,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 10,
  },
  bold: {
    fontWeight: 700,
  },
  block: {
    margin: '20px 0',
  },
  mb10: {
    marginBottom: 10,
  }
}))

export const PrivacyPolicyPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.h1}>
        Privacy Policy
      </Typography>
      <Typography className={classes.description}>
        Updated 5 Sep., 2022
      </Typography>

      <div className={classes.block} id="intro">
        <Typography>
          PropertyPower Ltd. is committed to protecting your privacy and personal information.
        </Typography>
        <ul>
          <li>
            <Typography>
              We will be transparent about the personal information we collect and what we do with it.
            </Typography>
          </li>
          <li>
            <Typography>
              We will use any personal information you share with us for the purposes described in our Privacy Policy, to provide you with services you have requested.
            </Typography>
          </li>
          <li>
            <Typography>
              We will put in place our utmost measures to keep your information secure.
            </Typography>
          </li>
          <li>
            <Typography>
              We will respect your privacy rights and aim to give you utmost control over your personal information.
            </Typography>
          </li>
          <li>
            <Typography>
              If you tell us you don’t want to receive marketing messages we will stop sending them. We will, of course, continue to send essential information relating to your services to keep you informed.
            </Typography>
          </li>
        </ul>
        <Typography className={classes.mb10}>
          You can access our full Privacy Policy for more details on what we use your personal information for, and <HashLink smooth to="#your_choices">your choices</HashLink> about it.
        </Typography>
        <Typography className={classes.mb10}>
          If you have further questions please contact us using the <HashLink smooth to="#contact_us">contact details below</HashLink>
        </Typography>
        <Typography className={classes.mb10}>
          Without prejudice to your rights under applicable laws, the above and the Privacy Policy are not contractual and do not form part of your contract with us.
        </Typography>
      </div>

      <div className={classes.block} id="personal_information_we_collect">
        <Typography className={classes.title}>
          Personal information we collect
        </Typography>
        <Typography className={classes.mb10}>
          Personal information means data that identify you, such as your name and contact details.
        </Typography>

        <Typography>
          <Typography className={classes.bold} component="span">Information you provide to us.</Typography> Personal information you provide to us may include:
        </Typography>
        <ul>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Contact data</Typography>, such as your first and last name, email address, and website.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Profile data</Typography>, such as your public name, wallet address, username and password that you may set to establish an online account on the Service, and any other information that you add to your account profile.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Communications</Typography> that we exchange with you, including when you contact us through the Service, social media, or otherwise.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Transactional data</Typography>, such as blockchain transaction history and information relating to or needed to complete your purchase on or through the Service.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Marketing data</Typography>, such as your preferences for receiving our marketing communications and details about your engagement with them.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Financial data</Typography>, such as your virtual currency or wallet accounts, stored value accounts, and associated details.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Other data </Typography> not specifically listed here, which we will use as described in this Privacy Policy or as otherwise disclosed at the time of collection.
            </Typography>
          </li>
        </ul>

        <Typography>
          <Typography className={classes.bold} component="span">Third-party sources.</Typography> We may combine personal information we receive from you with personal information we obtain from other sources, such as:
        </Typography>
        <ul>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Public sources</Typography>, such as public blockchains and ledgers and other publicly available sources.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Marketing partners</Typography>, such as joint marketing partners.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Third-party services</Typography>, such as virtual currency account services, that you use to log into, or otherwise link to, your Service account. This data may include your username, profile picture, wallet address, and other information associated with your account on that third-party service that is made available to us based on your account settings on that service.
            </Typography>
          </li>
        </ul>


        <Typography>
          <Typography className={classes.bold} component="span">Automatic data collection</Typography>. We, our service providers, and our business partners may automatically log information about you or your computer or mobile device, and your interaction over time with the Service, our communications and other online services, such as:
        </Typography>
        <ul>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Device data</Typography>, such as your computer&apos;s or mobile device&apos;s operating system type and version, manufacturer and model, browser type, screen resolution, RAM and disk size, CPU usage, device type (e.g., phone, tablet), IP address, unique identifiers, language settings, mobile device carrier, radio/network information (e.g., Wi-Fi, LTE, 3G), and general location information such as city, state or geographic area.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Online activity data</Typography>, such as pages or screens you viewed, how long you spent on a page or screen, the website you visited before browsing to the Service, navigation paths between pages or screens, information about your activity on a page or screen, access times and duration of access, and whether you have opened our emails or clicked links within them.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Precise geolocation data</Typography> when you authorize the Service to access your device&apos;s location.
            </Typography>
          </li>
        </ul>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Cookies</Typography>. Some of our automatic data collection may be facilitated by cookies and similar technologies. For more information, see our Cookie Notice.
        </Typography>

        <Typography>
          <Typography className={classes.bold} component="span">Data about others</Typography>. We may offer features that help users invite their friends or contacts to use the Service, and we may collect contact details about these invitees so we can deliver their invitations. Please do not refer someone to us or share their contact details or personal information with us unless you have their permission to do so.
        </Typography>

      </div>

      <div className={classes.block} id="how_we_use_your_personal_information">
        <Typography className={classes.title}>
          How we use your personal information
        </Typography>
        <Typography className={classes.mb10}>
          We may use your personal information for the following purposes or as otherwise described at the time of collection:
        </Typography>

        <Typography>
          <Typography className={classes.bold} component="span">Service delivery</Typography>. We may use your personal information to:
        </Typography>

        <ul>
          <li>
            <Typography>
              provide, operate and improve the Service and our business;
            </Typography>
          </li>
          <li>
            <Typography>
              establish and maintain your user profile on the Service;
            </Typography>
          </li>
          <li>
            <Typography>
              facilitate your invitations to other people or entities you want to invite to use the Service;
            </Typography>
          </li>
          <li>
            <Typography>
              enable security features of the Service, such as by sending you security codes via email or SMS, and remembering devices from which you have previously logged in;
            </Typography>
          </li>
          <li>
            <Typography>
              communicate with you about the Service, including by sending announcements, updates, security alerts, and support and administrative messages; and
            </Typography>
          </li>
          <li>
            <Typography>
              provide support for the Service, and respond to your requests, questions and feedback.
            </Typography>
          </li>
        </ul>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Research</Typography>. We may use your personal information for research purposes, including to analyze and improve the services we provide you.
        </Typography>
        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Marketing</Typography>. We may send you direct marketing communications. You may opt-out of marketing communications as described in the Your choices section.
        </Typography>
        <Typography>
          <Typography className={classes.bold} component="span">Compliance and protection</Typography>. We may use your personal information to:
        </Typography>

        <ul>
          <li>
            <Typography>
              comply with applicable laws, lawful requests, and legal process, such as to respond to subpoenas or requests from government authorities;
            </Typography>
          </li>
          <li>
            <Typography>
              protect our, your or others rights, privacy, safety or property (including by making and defending legal claims);
            </Typography>
          </li>
          <li>
            <Typography>
              audit our internal processes for compliance with legal and contractual requirements or our internal policies;
            </Typography>
          </li>
          <li>
            <Typography>
              enforce the terms and conditions that govern the Service; and
            </Typography>
          </li>
          <li>
            <Typography>
              prevent, identify, investigate and deter fraudulent, harmful, unauthorized, unethical or illegal activity, including cyberattacks and identity theft.
            </Typography>
          </li>
        </ul>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">With your consent</Typography>. In some cases, we may specifically ask for your consent to collect, use or share your personal information, such as when required by law.
        </Typography>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">To create anonymous, aggregated or de-identified data</Typography>. We may create anonymous, aggregated or de-identified data from your personal information and other individuals whose personal information we collect. We make personal information into anonymous, aggregated or de-identified data by removing information that makes the data identifiable. We may use this anonymous, aggregated or de-identified data and share it with third parties for our lawful business purposes, including to analyze and improve the Service and promote our business.
        </Typography>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Cookies and similar technologies</Typography>. We may use these for the purposes outlined in the &quot;Cookie Notice.&quot;
        </Typography>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Retention</Typography>. We retain Personal Information to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements, to establish or defend legal claims, or for fraud prevention purposes. To determine the appropriate retention period for Personal Information, we consider factors such as the amount, nature, and sensitivity of the Personal Information, the potential risk of harm from unauthorized use or disclosure of your Personal Information, the purposes for which we process your Personal Information, and whether we can achieve those purposes through other means, and the applicable legal requirements.
        </Typography>

        <Typography>
          When we no longer require the Personal Information we have collected about you, we will either delete it, anonymize it or, if this is not possible (for example, because your Personal Information has been stored in backup archives), securely store it and isolate it from further processing until deletion is possible. If we anonymize your Personal Information (so that it can no longer be associated with you), we may use this information indefinitely without further notice to you.
        </Typography>

      </div>

      <div className={classes.block} id="how_we_share_your_personal_information">
        <Typography className={classes.title}>
          How we share your personal information
        </Typography>
        <Typography>
          We may share your personal information with the following parties and as otherwise described in this Privacy Policy or at the time of collection.
        </Typography>
        <ul>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Affiliates</Typography>. Our corporate parent, any subsidiaries, and affiliates, for purposes consistent with this Privacy Policy.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Service providers</Typography>. Third parties that provide services on our behalf or help us operate the Service or our business (such as hosting, information technology, customer support, email delivery, marketing, and website analytics).
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Cryptocurrency platforms</Typography>. Any information collected necessary to complete a transaction (such as your wallet address) is collected and processed directly by your chosen cryptocurrency platform. Please review the privacy policies for the relevant cryptocurrency platform(s) to learn how they may use your personal information.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Third parties designated by you</Typography>. We may share your personal data with third parties where you have instructed us or provided your consent to do so.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Business and marketing partners</Typography>. Third parties with whom we jointly offer products or services, or whose products or services may be of interest to you.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Professional advisors</Typography>. Professional advisors, such as lawyers, auditors, bankers and insurers, where necessary in the course of the professional services that they render to us.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Authorities and others</Typography>. Law enforcement, government authorities, and private parties, as we believe in good faith to be necessary or appropriate for the <a href="https://www.flowcarbon.com/privacy-policy" target="_blank" rel="noreferrer">compliance and protection purposes</a> described <HashLink smooth to="#how_we_use_your_personal_information">herein</HashLink>
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Business transferees</Typography>. Acquirers and other relevant participants in business transactions (or negotiations of or due diligence for such transactions) involving a corporate divestiture, merger, consolidation, acquisition, reorganization, sale or other disposition of all or any portion of the business or assets of, or equity interests in, PropertyPower or our affiliates (including, in connection with a bankruptcy or similar proceedings).
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Other users and the public</Typography>. Your profile may be visible to other users of the Service and the public. For example, other users of the Service or the public may have access to your information if you chose to make your profile or other personal information available to them through the Service. This information can be seen, collected and used by others, including being cached, copied, screen captured or stored elsewhere by others (e.g., search engines), and we are not responsible for any such use of this information.
            </Typography>
          </li>
        </ul>

      </div>

      <div className={classes.block} id="your_choices">

        <Typography className={classes.title}>
          Your choices
        </Typography>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Access or update your information</Typography>. If you have registered for an account with us through the Service, you may review and update certain account information by logging into the account.
        </Typography>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Opt-out of marketing communications</Typography>. You may opt-out of marketing-related emails by following the opt-out or unsubscribe instructions at the bottom of the email, or by <HashLink smooth to="#contact_us">contacting us</HashLink>. Please note that if you choose to opt-out of marketing-related emails, you may continue to receive service-related and other non-marketing emails.
        </Typography>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Declining to provide information</Typography>. We need to collect personal information to provide certain services. If you do not provide the information we identify as required or mandatory, we may not be able to provide those services.
        </Typography>

      </div>

      <div className={classes.block} id="other_sites_and_services">
        <Typography className={classes.title}>
          Other sites and services
        </Typography>

        <Typography>
          The Service may contain links to websites, mobile applications, and other online services operated by third parties. In addition, our content may be integrated into web pages or other online services that are not associated with us. These links and integrations are not an endorsement of, or representation that we are affiliated with, any third party. We do not control websites, mobile applications or online services operated by third parties, and we are not responsible for their actions. We encourage you to read the privacy policies of any other websites, mobile applications and online services you use.
        </Typography>
      </div>

      <div className={classes.block} id="security">
        <Typography className={classes.title}>
          Security
        </Typography>

        <Typography>
          We employ a number of technical, organizational and physical safeguards designed to protect the personal information we collect. However, security risk is inherent in all internet and information technologies and we cannot guarantee the security of your personal information.
        </Typography>
      </div>

      <div className={classes.block} id="international_data_transfer">
        <Typography className={classes.title}>
          International data transfer
        </Typography>

        <Typography className={classes.mb10}>
          We are headquartered in Israel and may use service providers that operate in other countries. Your personal information may be transferred to Israel or other locations where privacy laws may not be different than those in your state or country.
        </Typography>

        <Typography>
          Users in the United Kingdom, Switzerland, and the European Economic Area (&quot;EEA&quot;) should read the important information provided below about transfer of personal information outside of the European Union.
        </Typography>
      </div>

      <div className={classes.block} id="children">
        <Typography className={classes.title}>
          Children
        </Typography>

        <Typography>
          The Service is not intended for use by anyone under 18 years of age. If you are a parent or guardian of a child from whom you believe we have collected personal information in a manner prohibited by law, please contact us. If we learn that we have collected personal information through the Service from a child without the consent of the child&apos;s parent or guardian as required by law, we will comply with applicable legal requirements to delete the information.
        </Typography>
      </div>

      <div className={classes.block} id="changes_to_this_privacy_policy">
        <Typography className={classes.title}>
          Changes to this Privacy Policy
        </Typography>

        <Typography>
          We reserve the right to modify this Privacy Policy at any time. If we make material changes to this Privacy Policy, we will notify you by updating the date of this Privacy Policy and posting it on the Service or other appropriate means. Any modifications to this Privacy Policy will be effective upon our posting the modified version (or as otherwise indicated at the time of posting). In all cases, your use of the Service after the effective date of any modified Privacy Policy indicates your acceptance of the modified Privacy Policy.
        </Typography>
      </div>

      <div className={classes.block} id="contact_us">
        <Typography className={classes.title}>
          How to contact us
        </Typography>

        <Typography>
          <Typography className={classes.bold} component="span">Email</Typography>: privacy@propertypower.com
        </Typography>
      </div>

      <div className={classes.block} id="notice_to_european_users">
        <Typography className={classes.title}>
          Notice to European users
        </Typography>
        <Typography className={classes.mb10}>
          The information provided in this &quot;Notice to European users&quot; section applies only to individuals in the United Kingdom, Switzerland, and the European Economic Area (hereafter collectively referred to as &quot;Europe&quot;).
        </Typography>
        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Controller</Typography>. PropertyPower Ltd is the controller of your Personal Information covered by this Privacy Policy for purposes of European data protection legislation. See the <HashLink smooth to="#contact_us">How to contact us</HashLink> section for contact details.
        </Typography>
        <Typography>
          <Typography className={classes.bold} component="span">Legal bases for processing</Typography>. We use your Personal Information only as permitted by law. The European data protection legislation requires us to ensure we have a &quot;legal basis&quot; for each purpose for which we collect your Personal Information. Our legal bases for processing the Personal Information described in this Privacy Policy are described in the table below:
        </Typography>
        <ul>
          <li>
            <Typography>
              Where we need to perform a contract that we are about to enter into, or have entered into, with you (&quot;<Typography className={classes.bold} component="span">Contractual Necessity</Typography>&quot;).
            </Typography>
          </li>
          <li>
            <Typography>
              Where it is necessary for our legitimate interests and your interests and fundamental rights do not override those interests (&quot;<Typography className={classes.bold} component="span">Legitimate Interests</Typography>&quot;). More detail about the specific legitimate interests pursued in respect of each purpose we use your Personal Information for is set out in the table below.
            </Typography>
          </li>
          <li>
            <Typography>
              Where we need to comply with a legal or regulatory obligation (&quot;<Typography className={classes.bold} component="span">Compliance with Law</Typography>&quot;)
            </Typography>
          </li>
          <li>
            <Typography>
              Where we have your specific consent to carry out the processing for the Purpose in question (&quot;<Typography className={classes.bold} component="span">Consent</Typography>&quot;). Generally, we do not rely on your Consent as a legal basis for using your Personal Information other than in the context of direct marketing communications.
            </Typography>
          </li>
        </ul>

        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Use for new purposes</Typography>. We may use your Personal Information for reasons not described in this Privacy Policy where permitted by law and the reason is compatible with the purpose for which we collected it. If we need to use your Personal Information for an unrelated purpose, we will notify you and explain the applicable legal basis.
        </Typography>
        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Sensitive Personal Information</Typography>. We ask that you not provide us with any sensitive Personal Information (e.g., social security numbers, information related to racial or ethnic origin, political opinions, religion or other beliefs, health, biometrics or genetic characteristics, criminal background or trade union membership) on or through the services, or otherwise to us. If you provide us with any sensitive Personal Information to us when you use the services, you must consent to our processing and use of such sensitive Personal Information in accordance with this Privacy Policy. If you do not consent to our processing and use of such sensitive Personal Information, you must not submit such sensitive Personal Information through our services.
        </Typography>
        <Typography className={classes.mb10}>
          <Typography className={classes.bold} component="span">Automated Decision-Making and Profiling</Typography>. We may use automated decision-making and/or profiling with regard to Personal Information, for example automatic handling or rejection of an application. You may request a manual review of an automated decision that relates to your Personal Information by <HashLink smooth to="#contact_us">contacting us</HashLink>
        </Typography>
        <Typography>
          <Typography className={classes.bold} component="span">Your rights</Typography>. European data protection legislation secures your rights in regard to your Personal Information. If you are located in Europe, you may request we take the following actions regarding your Personal Information:
        </Typography>
        <ul>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right of access</Typography>: You can ask us to provide you with information about our processing of your Personal Information and access to it.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right to rectification</Typography>: If the Personal Information we hold about you is inaccurate or incomplete, you are entitled to request to have it rectified.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right to erasure</Typography>: You can ask us to delete or remove your Personal Information where there is no lawful reason for us continuing to store or process it, where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully or where we are required to erase your Personal Information to comply with local law.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right to restrict processing</Typography>: You can ask us to suspend the processing of your Personal Information if: (i) you want us to establish the data&quot;s accuracy; (ii) where our use of the data is unlawful but you do not want us to erase it; (iii) where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or (iv) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right to object</Typography>: Where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation that makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right to data portability</Typography>: You have the right, in certain circumstances, to ask us to provide to you, or a third party you have chosen, your Personal Information in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.
            </Typography>
          </li>
          <li>
            <Typography>
              <Typography className={classes.bold} component="span">Right to withdraw consent at any time</Typography>: Where we are relying on consent to process your Personal Information you have the right to withdraw your consent at any time. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent.
            </Typography>
          </li>
        </ul>
        <Typography className={classes.mb10}>
          Please note that some of these rights may be limited where we have an overriding interest or legal obligation to continue to process the Personal Information or where certain exemptions apply. If we decline your request, we will tell you why, subject to legal restrictions.
        </Typography>
        <Typography className={classes.mb10}>
          To exercise any of these rights, please <HashLink smooth to="#contact_us">contact us</HashLink>. We may request specific information from you to help us confirm your identity and process your request.
        </Typography>
        <Typography className={classes.mb10}>
          We encourage you to contact us first to find a solution for any concern you may have, however you always have the right to complain to your <a href="https://edpb.europa.eu/about-edpb/board/members_en" target="_blank" rel="noreferrer">data protection authority</a>.
        </Typography>
        <Typography>
          <Typography className={classes.bold} component="span">Cross-border data transfer</Typography>. We may transfer your Personal Information to recipients outside of the EEA and/or the UK. Some of these recipients are located in countries in respect of which either the European Commission and/or UK Government (as and where applicable) has issued adequacy decisions, in which case, the recipient&quot;s country is recognized as providing an adequate level of data protection under UK and/or European data protection laws (as applicable) and the transfer is therefore permitted under Article 45 of the GDPR. Some recipients of your Personal Information may be located in countries outside the EEA and/or the UK for which the European Commission or UK Government (as and where applicable) has not issued adequacy decisions in respect of the level of data protection in such countries (&quot;<Typography className={classes.bold} component="span">Restricted Country</Typography>&quot;). For example, the United States is a Restricted Country. When we transfer your Personal Information to a recipient in a Restricted Country, we will either:
        </Typography>
        <ul>
          <li>
            <Typography>
              enter into appropriate data transfer agreements based on the EEA or UK Standard Contractual Clauses (as applicable) as approved from time-to-time by the European Commission under Article 46 of the GDPR, the UK Information Commissioner&quot;s Office or UK Government (as and where applicable); or
            </Typography>
          </li>
          <li>
            <Typography>
              rely on other appropriate means permitted by the EEA/UK GDPR, which establish that such recipients will provide an adequate level of data protection and that appropriate technical and organizational security measures are in place to protect Personal Information against accidental or unlawful destruction, loss or alteration, unauthorized disclosure or access, and against all other unlawful forms of processing.
            </Typography>
          </li>
        </ul>

        <Typography>
          You may ask for a copy of such appropriate specific data transfer mechanism by <HashLink smooth to="#contact_us">contacting us</HashLink>
        </Typography>
      </div>

    </div>
  )
}
